import { createContext, useContext, useState } from "react";

const PetitionContext = createContext();

export const usePetition = () => useContext(PetitionContext);

export const PetitionProvider = ({ children }) => {
    const [petitionId, setPetitionId] = useState(null);

    return (
        <PetitionContext.Provider value={{ petitionId, setPetitionId }}>
            {children}
        </PetitionContext.Provider>
    );
};